import { render, staticRenderFns } from "./ffDataSlotList.vue?vue&type=template&id=4b0be950&lang=true&"
import script from "./ffDataSlotList.vue?vue&type=script&lang=js&"
export * from "./ffDataSlotList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports